import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;


export default class Offer {

  static endpoints = {
    index   : `${baseUrl}/offers`,
    history : `${baseUrl}/offers/history`,
  };

  static postbackType = {
    CLAIM   : 1,
    REVERSAL: 2
  };

  static find(payload) {
    return axios.post(this.endpoints.index, payload).then((response)=> response.data.offers);
  };

  static history() {
    return axios.get(this.endpoints.history).then((response)=> response.data);
  };

  static findByShareId(shareId) {
    return axios.get(`${this.endpoints.index}/find/shareId/${shareId}`).then((response)=> response.data.offer);
  };

}

